import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-399fc61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-case" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "bg-white border-t border-r border-l px-6 pt-4 pb-4 grid grid-cols-1 gap-3" }
const _hoisted_5 = { class: "bg-white border-t border-b border-r border-l px-6 pt-4 pb-4 mt-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-3" }, "Краткое описание кейса", -1))
const _hoisted_7 = { class: "bg-white border-b border-r border-l px-6 pt-4 pb-4 mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-3" }, "Контент кейса", -1))
const _hoisted_9 = { class: "flex items-center justify-end mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_alert = _resolveComponent("alert")!
  const _component_quill_editor = _resolveComponent("quill-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Добавление кейса на сайт" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/cases')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Сортировка",
          value: _ctx.state.order,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.order) = $event)),
          "is-invalid": _ctx.state_form$.order.$error,
          "validation-errors": _ctx.state_form$.order.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Краткий заголовок",
          value: _ctx.state.shortTitle,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.shortTitle) = $event)),
          "is-invalid": _ctx.state_form$.shortTitle.$error,
          "validation-errors": _ctx.state_form$.shortTitle.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Заголовок",
          value: _ctx.state.title,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.title) = $event)),
          "is-invalid": _ctx.state_form$.title.$error,
          "validation-errors": _ctx.state_form$.title.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Заголовок формы",
          value: _ctx.state.feedbackHeader,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.feedbackHeader) = $event)),
          "is-invalid": _ctx.state_form$.feedbackHeader.$error,
          "validation-errors": _ctx.state_form$.feedbackHeader.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Meta заголовок",
          value: _ctx.state.titleForDisplay,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.titleForDisplay) = $event))
        }, null, 8, ["disabled", "value"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          placeholder: "Meta описание",
          value: _ctx.state.descriptionForDisplay,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.descriptionForDisplay) = $event))
        }, null, 8, ["disabled", "value"]),
        _createVNode(_component_file_reader, {
          class: "mt-2",
          placeholder: "Изображение превью",
          value: _ctx.state.previewImage,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.previewImage) = $event)),
          accept: "image/*",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.previewImage.$error,
          "validation-errors": _ctx.state_form$.previewImage.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_file_reader, {
          class: "mt-2",
          placeholder: "Основное изображение",
          value: _ctx.state.mainImage,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.mainImage) = $event)),
          accept: "image/*",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.mainImage.$error,
          "validation-errors": _ctx.state_form$.mainImage.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          disabled: _ctx.state.is_loading,
          searchable: false,
          placeholder: "Статус",
          value: _ctx.state.statusId,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.statusId) = $event)),
          "is-invalid": _ctx.state_form$.statusId.$error,
          "validation-errors": _ctx.state_form$.statusId.$errors,
          options: _ctx.STATUSES
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.state_form$.shortDescription.$error)
          ? (_openBlock(), _createBlock(_component_alert, {
              key: 0,
              class: "red mb-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Заполните краткое описание кейса ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_quill_editor, {
          contentType: "html",
          content: _ctx.state.shortDescription,
          "onUpdate:content": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.shortDescription) = $event)),
          toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'header': [2, false] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'align': [] }],
                        ['link', 'image', 'video'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['clean']
                    ],
          modules: _ctx.quillModules,
          options: { placeholder: 'Краткое описание кейса' },
          disabled: _ctx.state.is_loading
        }, null, 8, ["content", "modules", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.state_form$.description.$error)
          ? (_openBlock(), _createBlock(_component_alert, {
              key: 0,
              class: "red mb-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Заполните контент кейса ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_quill_editor, {
          contentType: "html",
          content: _ctx.state.description,
          "onUpdate:content": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.description) = $event)),
          toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'header': [2, false] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'align': [] }],
                        ['link', 'image', 'video'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['clean']
                    ],
          modules: _ctx.quillModules,
          options: { placeholder: 'Контент кейса' },
          disabled: _ctx.state.is_loading
        }, null, 8, ["content", "modules", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" Добавить кейс ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}